import { render, staticRenderFns } from "./cap.vue?vue&type=template&id=12c593a1&"
import script from "./cap.vue?vue&type=script&lang=js&"
export * from "./cap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports